import React, { useState } from 'react';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { Card, Table, Tag, Button, Space, message, Modal, Form, Input, Switch, Popconfirm } from 'antd';
import { ThunderboltOutlined, PlusOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { adminApi } from '../../../api/client';

export function FeatureFlagsTab() {
    const queryClient = useQueryClient();

    const { data: flags, isLoading } = useQuery({
        queryKey: ['featureFlags'],
        queryFn: async () => (await adminApi.getFeatureFlags()).data,
    });

    const toggleMutation = useMutation({
        mutationFn: (id: string) => adminApi.toggleFeatureFlag(id),
        onSuccess: () => {
            message.success('Odświeżono stan modułu');
            queryClient.invalidateQueries({ queryKey: ['featureFlags'] });
        },
    });

    return (
        <div>
            <Card
                title={<Space><ThunderboltOutlined /> Moduły</Space>}
                loading={isLoading}
            >
                <Table
                    dataSource={flags || []}
                    rowKey="id"
                    pagination={{ pageSize: 20 }}
                    scroll={{ x: 'max-content' }}
                    columns={[
                        { title: 'Moduł / Funkcja', dataIndex: 'name', key: 'name' },
                        { title: 'Kategoria', dataIndex: 'moduleName', key: 'moduleName', render: (mod: string) => mod ? <Tag color="blue">{mod}</Tag> : '-' },
                        { title: 'Opis', dataIndex: 'description', key: 'description' },
                        {
                            title: 'Status',
                            key: 'isEnabled',
                            render: (_: any, record: any) => (
                                <Switch
                                    checked={record.isEnabled}
                                    onChange={() => toggleMutation.mutate(record.id)}
                                    checkedChildren="WŁĄCZONE"
                                    unCheckedChildren="WYŁĄCZONE"
                                />
                            )
                        },
                    ]}
                />
            </Card>
        </div>
    );
}
